import apiClient from '@/services/apiClient';
import store from '@/store/store';

export default {
	namespaced: true,
	state: {
		modulePromotion: null,
		promotion: null,
	},
	getters: {
		modulePromotion(state) {
			return state.modulePromotion;
		},
		promotion(state) {
			return state.promotion;
		},
	},
	mutations: {
		SET_MODULE_PROMOTION(state, modulePromotion) {
			state.modulePromotion = modulePromotion
		},
		SET_PROMOTION(state, promotion) {
			state.promotion = promotion
		},
		CLEAR_STORE(state) {
			state.modulePromotion = null;
			state.promotion = null;
		}
	},
	actions: {
		init({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/promotion/get').then(res => {
					commit('SET_MODULE_PROMOTION', res.data);
					if (res.data.active) {
						apiClient.get('modules/promotion/promotion/get').then(res => {
							commit('SET_PROMOTION', res.data);
							resolve(res.data);
						}).catch(err => {
							reject(err);
						})
					} else {
						resolve(res.data);
					}
				}).catch(err => {
					reject(err);
				})
			});
		},
		activate({commit}) {
			return store.dispatch('promotion/moduleUpdate', {active: 1});
		},
		deactivate({commit}) {
			return store.dispatch('promotion/moduleUpdate', {active: 0});
		},
		moduleUpdate({commit}, params) {
			return new Promise((resolve, reject) => {
				apiClient.put('modules/promotion/update', params).then(res => {
					commit('SET_MODULE_PROMOTION', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		save({commit}, params) {
			if (Object.keys(this.state.promotion.promotion).length === 0) {
				return new Promise((resolve, reject) => {
					apiClient.post('modules/promotion/promotion/create', params).then(res => {
						commit('SET_PROMOTION', res.data);
						resolve(res.data);
					}).catch(err => {
						reject(err);
					})
				});
			} else {
				return new Promise((resolve, reject) => {
					apiClient.put('modules/promotion/promotion/update', params).then(res => {
						commit('SET_PROMOTION', res.data);
						resolve(res.data);
					}).catch(err => {
						reject(err);
					})
				});
			}
		},
		async clear({commit}) {
			commit('CLEAR_STORE');
		}
	}
}
